export default __webpack_public_path__ + "static/media/icon_pages_button_shareemail_enabled.c431a3e4.svg";